import { BaseText, EBaseTextSize, EBaseTextWeight } from '@spinwise/react-component-library/BaseText';
import { IApplicationState, OVERLAY_PROMOTION_SHOW } from '@spinwise/spinwise-core';
import { ButtonLibrary } from 'Libraries/buttons.library';
import { useDispatch, useSelector } from 'react-redux';
import styles from './SignUpBlock.module.scss';
import router from 'next/router';
import classNames from 'classnames';
import { EOverlayContentWidth, POSITIONS } from 'Components/shared/Overlay/elements/OverlayFixedBg/types';
import { EBrandTextColor } from 'Libraries/typography.library';
import { basicChannel } from 'src/channels/basic.channel';
import { EComponentVisibility } from '@spinwise/react-component-library/Global';
import { ButtonTextOnly } from '@spinwise/react-component-library/ButtonTextOnly';
import {
  EBaseButtonSize,
  EBaseButtonTypeAttribute,
  EButtonBorderRadiusStrength,
  EButtonTextAlign,
} from '@spinwise/react-component-library/ButtonAbstract';
import { EBasicOverlays } from 'Components/shared/Overlay/elements/BasicOverlayManager/types';

export interface ISignUpBlock {
  title?: string;
  authorized_title?: string;
  btn_url?: string;
  authorized_btn_url?: string;
  btn_text?: string;
  authorized_btn_text?: string;
  terms: any;
}

const SignUpBlock = (props: ISignUpBlock) => {
  const loggedIn = useSelector((state: IApplicationState) => state.authReducer.auth?.success);

  const dispatch = useDispatch();

  const closePromotionOverlay = () => {
    dispatch({
      type: OVERLAY_PROMOTION_SHOW,
      content: {
        show: false,
      },
    });
  };

  const onButtonClick = () => {
    closePromotionOverlay();

    if (loggedIn) {
      router.push(props?.authorized_btn_url);
    } else {
      router.push(props?.btn_url);
    }
  };

  const openTerms = (title: string, info_page: any) => {
    basicChannel.send({
      action: 'display',
      data: {
        content: {
          type: EBasicOverlays.InfoPage,
          overlayTitle: title,
          info_page: info_page,
        },
        position: POSITIONS.TOP,
        contentWidth: EOverlayContentWidth.LARGE,
      },
    });
  };

  return (
    <div className={styles.sign_up_block}>
      <h2 className={styles.sign_up_block__title}>{loggedIn ? props?.authorized_title : props?.title}</h2>
      <div className={classNames(styles.sign_up_block__button, EComponentVisibility.DesktopOnly)}>
        <ButtonTextOnly
          label={loggedIn ? props?.authorized_btn_text : props?.btn_text}
          textSize={EBaseTextSize.Title4}
          size={EBaseButtonSize.Medium}
          type={ButtonLibrary.Primary}
          borderRadius={EButtonBorderRadiusStrength.Eight}
          typeAttribute={EBaseButtonTypeAttribute.Submit}
          fullWidth={true}
          alignText={EButtonTextAlign.Center}
          onClick={() => onButtonClick()}
        />
      </div>
      <div className={EComponentVisibility.MobileTablet}>
        <ButtonTextOnly
          label={loggedIn ? props?.authorized_btn_text : props?.btn_text}
          textSize={EBaseTextSize.Large}
          size={EBaseButtonSize.Medium}
          type={ButtonLibrary.Primary}
          borderRadius={EButtonBorderRadiusStrength.Eight}
          typeAttribute={EBaseButtonTypeAttribute.Submit}
          fullWidth={true}
          alignText={EButtonTextAlign.Center}
          onClick={() => onButtonClick()}
        />
      </div>
      {props?.terms?.data !== null && (
        <div
          className={styles.sign_up_block__terms}
          onClick={() => {
            openTerms(props?.terms?.data?.attributes?.title, props?.terms);
          }}
        >
          <BaseText
            value={props?.terms?.data?.attributes?.title}
            size={EBaseTextSize.Regular}
            weight={EBaseTextWeight.W400}
            color={EBrandTextColor.DarkViolet}
          />
        </div>
      )}
    </div>
  );
};

export default SignUpBlock;
